import React from "react";
import Thiswrong from "../../../img/view/close.png";
import Thiscorrect from "../../../img/view/check-mark.png";

export default function Item ({answer, item, active, setActive }) {
  const image = item.image && item.image !== '' && (
    <img src={item.image} alt={item.text} width='170' />
  )
  function handleClick () {
    setActive(item);
  }
  const activated = active?.text === item.text
  const activeStyles = activated ? { background: '#72B5A4', color:"#ffffff", transform:"scale(1.5, 1.5)"} : {}
    const correctIcon = answer === true && (<img className="correctandincorrect" src={Thiscorrect} width="20px"/>)
    const incorrectIcon = answer === false && (<img className="correctandincorrect" src={Thiswrong} width="20px"/>)
  return (
   <div>
     <div onClick={handleClick} style={{ padding: '5px 8px', margin: '5px', textAlign:"center", borderRadius:"8px", fontFamily: "forma-djr-micro, sans-serif", ...activeStyles }}>
        <>{correctIcon}
            {incorrectIcon}</>
         <span>{item.text}</span>
         <br/>
        {image}
      </div>
    </div>
  )
}
